import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Screenshot = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.074 4.836A3 3 0 0 1 10.57 3.5h2.86a3 3 0 0 1 2.496 1.336l.812 1.219a1 1 0 0 0 .832.445H19a3 3 0 0 1 3 3V17a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9.5a3 3 0 0 1 3-3h1.43a1 1 0 0 0 .832-.445zM12 9c-2 0-3.5 1.567-3.5 3.5a3.5 3.5 0 1 0 7 0C15.5 10.567 14 9 12 9'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.074 4.836A3 3 0 0 1 10.57 3.5h2.86a3 3 0 0 1 2.496 1.336l.812 1.219a1 1 0 0 0 .832.445H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h1.43a1 1 0 0 0 .832-.445zM12 9.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7'
        fill='currentColor'
      />
    )}
  </IconBase>
);
